/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterF = createReactComponent("letter-f", "IconLetterF", [
  ["path", { d: "M17 4h-10v16", key: "svg-0" }],
  ["path", { d: "M7 12l8 0", key: "svg-1" }]
]);

export { IconLetterF as default };
//# sourceMappingURL=IconLetterF.js.map
